// ── DB 관리 — 헬퍼 함수 ──────────────────────────────────────────────────────
import React from 'react';
import { TYPE_COLORS } from './constants';

/** 컬럼 타입명에 해당하는 배지 색상 반환 */
export function typeColor(type) {
  const key = String(type || '').toLowerCase();
  return TYPE_COLORS[key] || { bg: 'var(--bg-subtle)', text: 'var(--text-sub)' };
}

/** 숫자를 한국어 천 단위 구분 형식으로 표시 */
export function fmtNum(n) {
  if (n == null || n === '') return '-';
  return Number(n).toLocaleString('ko-KR');
}

/**
 * 테이블 셀 값을 읽기 전용 형태로 렌더링
 * - null/undefined  → 이탤릭 회색 "null" span
 * - 객체/배열       → 보라색 JSON 문자열 span
 * - "***" (마스킹)  → 점 3개 span
 * - 그 외           → 문자열 그대로
 */
export function fmtCell(val) {
  if (val === null || val === undefined)
    return <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>null</span>;
  if (typeof val === 'object')
    return <span style={{ color: '#7c3aed', fontSize: 11 }}>{JSON.stringify(val)}</span>;
  if (val === '***')
    return <span style={{ color: 'var(--text-muted)', letterSpacing: 2 }}>●●●</span>;
  return String(val);
}

/** 스키마 정보에서 PK 컬럼명 추출 (없으면 'id' 반환) */
export function extractPkColumn(schema) {
  if (!schema?.indexes) return 'id';
  const pkIdx = schema.indexes.find((i) => i.is_primary);
  return pkIdx?.columns?.[0] || 'id';
}
